import { AnyAction } from "redux";
import { SET_EDIT_ROLE_USERS_LOADED } from "../actions/loadingEditRoleUsers";

export const loadingEditRoleUsers = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_EDIT_ROLE_USERS_LOADED:
      return action.editRoleUsersLoaded;
    default:
      return state;
  }
};

export default loadingEditRoleUsers;
